// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

import { getPasswordTypeById } from 'app/constants/enums/PasswordType/main';

/* eslint-disable max-len */
export const STAFF = getPasswordTypeById('staff');
export const USER = getPasswordTypeById('user');
/* eslint-enable max-len */
